export default "<div class=\"row content\">\n  <div id=\"{{ prefix + '_' + selector }}\" class=\"col-12\" [style.height.px]=\"height\"></div>\n</div>\n"